import { SET_DESIGNATOR_LIST, SET_UNIQUE_DESIGNATOR_LIST, SET_DESIGNATOR } from './types.js'

export default {
  async fetchFeedDesignators ({ commit }) {
    try {
      const results = await this._vm.$network_utils.getAllFeedDesignators()
      commit(SET_DESIGNATOR, results)
      commit(SET_UNIQUE_DESIGNATOR_LIST, Array.from(new Set(results.map(item => item.designator))))
      const data = results.reduce((groups, item) => {
        return {
          ...groups,
          [item.group]: [...(groups[item.group] || []), item.designator]
        }
      }, {})
      for (const [k, v] of Object.entries(data)) {
        commit(SET_DESIGNATOR_LIST, {
          group: k,
          designators: v
        })
      }
    } catch {
      console.error('Problem with fetching server api on feed designator route')
    }
  }
}
